import { RequestError } from "./RequestError";

export const INVALID_JSON_RESPONSE = "invalid_json_response";

export async function readJsonResponse(response: Response): Promise<unknown> {
  const contentType = response.headers.get("Content-Type") ?? "";
  const mediaType = contentType.split(";")[0].trim().toLowerCase();
  try {
    if (mediaType !== "application/json" && !mediaType.endsWith("+json")) {
      throw new Error(INVALID_JSON_RESPONSE);
    }
    return await response.json();
  } catch {
    throw Object.assign(
      new RequestError(response.status, INVALID_JSON_RESPONSE),
      {
        contentType,
        code: INVALID_JSON_RESPONSE
      }
    );
  }
}
